export default "__VITE_ASSET__BVW$CXuw__"